/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const TRIGGER_VALIDATE_ORDER = 'MFE/MBP-CHECKOUT/TRIGGER_VALIDATE_ORDER';
const CALL_TO_TRIGGER_VALIDATE_ORDER = 'MFE/MBP-CHECKOUT/CALL_TO_TRIGGER_VALIDATE_ORDER';
const TRIGGER_VALIDATE_ORDER_COMPLETED = 'MFE/MBP-CHECKOUT/TRIGGER_VALIDATE_ORDER_COMPLETED';
const SKIP_VALIDATE_CART = 'MFE/MBP-CHECKOUT/SKIP_VALIDATE_CART';

export {
    CALL_TO_TRIGGER_VALIDATE_ORDER,
    TRIGGER_VALIDATE_ORDER,
    TRIGGER_VALIDATE_ORDER_COMPLETED,
    SKIP_VALIDATE_CART,
};
